import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sun, AlertTriangle } from "lucide-react";

/** Iter-34: Per-user paid-leave (CONGE) balance card. Hidden for freelances (applies=false). */
export default function LeaveBalanceCard() {
  const [b, setB] = useState(null);
  useEffect(() => {
    api.get("/me/leave-balance").then((r) => setB(r.data)).catch(() => setB(null));
  }, []);

  if (!b || !b.applies || (b.allowance === 0 && b.taken === 0)) return null;

  const pct = b.allowance > 0 ? Math.min(100, Math.round((b.taken / b.allowance) * 100)) : 0;
  const overflow = b.overflow > 0;

  return (
    <div data-testid="leave-balance-card" className="bg-white border border-zinc-200 rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <Sun size={18} className="text-sky-600" />
        <h2 className="font-heading text-lg font-bold tracking-tight">My leaves {b.year}</h2>
        {overflow && (
          <span data-testid="leave-overflow-pill" className="ml-auto inline-flex items-center gap-1 px-2 py-0.5 bg-red-100 text-red-700 rounded text-[11px] font-mono uppercase">
            <AlertTriangle size={11} /> dépassement
          </span>
        )}
      </div>

      <div className="grid grid-cols-3 gap-4 mb-4 text-center">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Pris</div>
          <div className="text-3xl font-bold text-sky-700 mt-1" data-testid="dash-leave-taken">{b.taken}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Restants</div>
          <div className={`text-3xl font-bold mt-1 ${b.remaining <= 5 ? "text-amber-600" : "text-emerald-600"}`} data-testid="dash-leave-remaining">{b.remaining}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Quota</div>
          <div className="text-3xl font-bold text-zinc-800 mt-1">{b.allowance}</div>
        </div>
      </div>

      <div className="h-2 bg-zinc-100 rounded-full overflow-hidden mb-2">
        <div
          className={`h-full transition-all ${overflow ? "bg-red-500" : pct >= 80 ? "bg-amber-500" : "bg-sky-500"}`}
          style={{ width: `${overflow ? 100 : pct}%` }}
        />
      </div>

      {overflow && (
        <div data-testid="dash-leave-overflow-block" className="mt-3 px-3 py-2 bg-red-50 border border-red-200 rounded text-xs text-red-900">
          <strong>{b.overflow} jour(s)</strong> au-delà du quota — comptabilisés en crédit sur l'année prochaine
          (limite : {b.credit_allowance} j).
        </div>
      )}
    </div>
  );
}
